import React from 'react'
import "./DashBoardSmallCard.css"
const DashBoardSmallCard = ({ allCount, name }) => {
  return (
    <div className='DashBoardSmallCard'>
      <p>{name}</p>
      <p className='DashBoardSmallCard_value'>{allCount}</p>
    </div>
  )
}

export default DashBoardSmallCard